import { pdf } from '@react-pdf/renderer';
import { registerPdfFonts } from './fonts/registerFonts';

registerPdfFonts();

export const ChatbeatPdfService = {
  async generate(document: React.ReactElement, filename: string): Promise<void> {
    const blob = await pdf(document).toBlob();
    const url = URL.createObjectURL(blob);

    const anchor = window.document.createElement('a');
    anchor.href = url;
    anchor.download = filename;
    anchor.click();

    URL.revokeObjectURL(url);
  },
};
